import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const CLIENT_TRIP_HISTORY: TableColumn[] = [
    {
        name: "billOfLading", 
        displayName: "Bill of Lading", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "containerQuantity", 
        displayName: "Container Qty", 
        dataType: COLUMN_TYPES.number, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "totalRate", 
        displayName: "Rate", 
        dataType: COLUMN_TYPES.currency, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "shippingLine", 
        displayName: "Shipping Line", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "tripStatus", 
        displayName: "Status", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "paymentStatus", 
        displayName: "Payment Status", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "createdBy", 
        displayName: "Created By", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {width: '30%'},
        reference: '',
        selectOptions: null
    }
]


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.client.trip.history.ts